import React from 'react';
import PropTypes from 'prop-types';
import HeaderSection from '../components/HeaderSection';
import InfoSection from '../components/InfoSection';
import ButtonSection from '../components/ButtonSection';
import InputSection from '../components/InputSection';
import CheckSection from '../components/CheckSection';
import SelectSection from '../components/SelectSection';
import {
  getSelectRating,
  DEFAULT,
  NOT_ACTIVE,
  ACTIVE,
  MODIFY,
} from '../constants';
import { connect } from 'react-redux';
import { compose } from 'redux';

const Active = ({
  isActive,
  errors,
  form,
  label,
  labelBtn,
  loading,
  onChange,
  onSave,
  onToggle,
  translations
}) => {
  const data = getSelectRating(translations);
  return (
    <div>
      <div className="row">
        <HeaderSection
          labelTitle={label.title}
          labelSubtitle={label.subTitle}
        />
      </div>

      <div className="row padding-top-1">
        <InfoSection
          key="key-pin_parental"
          className="col-md-5 col-xs-12 "
          labelTitle={label.controlPin.title}
          labelDescription={label.controlPin.description}
        />

        <div className="col-md-1" />
        <div className="col-md-6 col-xs-12">
          <CheckSection
            placeholder={label.input.placeholder}
            name="pin_parental"
            label={label.input.check}
            error={errors.pin_parental}
            value={form.pin_parental}
            onChange={onChange}
          />
          <SelectSection
            placeholder={label.input.placeholder}
            name="pin_ratings"
            label={label.input.select}
            value={form.pin_ratings || ''}
            onChange={onChange}
            disabled={!form.pin_parental}
            data={data}
          />
        </div>
      </div>
      <div className="row padding-top-1">
        <InfoSection
          key="key-pin_purchase"
          className="col-md-5 col-xs-12 "
          labelTitle={label.paymentProtection.title}
          labelDescription={label.paymentProtection.description}
        />

        <div className="col-md-1" />
        <div className="col-md-6 col-xs-12">
          <CheckSection
            placeholder={label.input.placeholder}
            name="pin_purchase"
            label={label.input.check}
            error={errors.pin_purchase}
            value={form.pin_purchase}
            onChange={onChange}
          />
        </div>
      </div>
      <div className="row padding-top-1">
        <InfoSection
          key="key-pin_code"
          className="col-md-5 col-xs-12 "
          labelTitle={label.confirm.title}
          labelDescription={label.confirm.description}
        />
        <div className="col-md-1" />
        <div className="col-md-6 col-xs-12">
          <InputSection
            className="col-md-6 col-xs-12"
            placeholder={label.input.placeholder}
            name="pin_code"
            label={label.input.text1}
            error={errors.pin_code}
            value={form.pin_code || ''}
            onChange={onChange}
          />
        </div>
      </div>

      <div className="row">
        <ButtonSection
          labelCancel={labelBtn.btnCancel}
          labelExec={labelBtn.btnConfirm}
          loading={loading}
          onToggle={() => onToggle(isActive ? DEFAULT : NOT_ACTIVE)}
          onExec={() => onSave(isActive ? MODIFY : ACTIVE)}
        />
      </div>
    </div>
  );
};

Active.propTypes = {
  isActive: PropTypes.bool,
  form: PropTypes.object,
  errors: PropTypes.object,
  label: PropTypes.object,
  labelBtn: PropTypes.object,
  loading: PropTypes.bool,
  onSave: PropTypes.func,
  onChange: PropTypes.func,
  onToggle: PropTypes.func,
};
const mapStateToProps = state => ({
  translations: state?.translations
});

const withConnect = connect(
  mapStateToProps,
);
export default compose(withConnect)(Active);
